import React, { useEffect, useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import { Backdrop, Box, Typography, CircularProgress, Grid, Pagination, Menu, MenuItem } from "@mui/material";
import { GetContentforParagraph } from "../../../utilities/chatgptconn";
import { InsertAIGenText } from "../../../utilities/Wordutil";
import DialogTitle from "@mui/material/DialogTitle";
//import Chip from "@mui/material/Chip";
//import Avatar from "@mui/material/Avatar";
//import IconButton from "@mui/material/IconButton";
//import EditIcon from "@mui/icons-material/Edit";

// import ButtonGroup from "@mui/material/ButtonGroup";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import ClickAwayListener from "@mui/material/ClickAwayListener";
// import Grow from "@mui/material/Grow";
// import Paper from "@mui/material/Paper";
// import Popper from "@mui/material/Popper";
//import MenuList from "@mui/material/MenuList";

/* global console */

export interface PreviewModalContentProps {
  processitem: any;
  headings: any;
  keepMounted: boolean;
  value: any;
  open: boolean;
  dlgparalist: any;
  onClose: (value?: any) => void;
}

const useStyles = makeStyles({
  root: {
    ".MuiDialogContent-root": {
      padding: "0px 0px 0px 0px !important",
      margin: 0,
    },
    "& .MuiDialog-paperWidthLg": {
      maxWidth: "none !important",
    },
    "& .MuiDialog-paper": {
      margin: 0,
    },
    "& .MuiDialogTitle-root": {
      padding: "1px !important",
      margin: 0,
    },
  },
  content: {
    "&:first-child": {
      padding: 0,
      margin: 0,
    },
  },
});

const PreviewModalContent = (props: PreviewModalContentProps) => {
  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const [tabvalue, settabvalue] = useState("1");
  const [isloading, setisloading] = useState(false);

  const [genheadings, setgenheadings] = useState([]);
  const [activeStep, setActiveStep] = React.useState(0);
  const [pagecount, setpagecount] = useState(0);

  const [genalternate, setgenalternate] = useState([]);
  const [gencaptions, setgencaptions] = useState([]);
  const [activeStep1, setActiveStep1] = React.useState(0);
  const [pagecount1, setpagecount1] = useState(0);

  const [dlgtitle, setdlgtitle] = useState("");
  const [btncaption, setbtncaption] = useState("Get text");
  const [gentype, setgentype] = useState("");
  const [sumtext, setsumtext] = useState("");
  const [sumcaption, setsumcaption] = useState("");
  const classes = useStyles();

  //Context Menu
  const [contextMenu, setContextMenu] = React.useState<{
    mouseX: number;
    mouseY: number;
  } | null>(null);

  const handleContextMenu = (event: React.MouseEvent) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
          // Other native context menus might behave different.
          // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
          null
    );
  };

  const handleClose = () => {
    setContextMenu(null);
  };
  //Context Menu

  const handlePageChange = (_event: React.ChangeEvent<unknown>, value: number) => {
    console.log("value");
    console.log(value);
    if (gentype === "version") {
      setActiveStep(value);
    } else {
      setActiveStep1(value);
    }
  };

  const handletabchange = (_event: React.SyntheticEvent, newValue: string) => {
    settabvalue(newValue);
    if (newValue === "1") {
      setgentype("version");
      setpagecount(0);
      setActiveStep(0);
      if (genheadings.length > 0) {
        setpagecount(genheadings.length);
        setActiveStep(1);
      }
    } else if (newValue === "2") {
      setgentype("alternate");
      setpagecount1(0);
      setActiveStep1(0);
      if (genalternate.length > 0) {
        setpagecount1(genalternate.length);
        setActiveStep1(1);
      } else {
        handleRegenerate("alternate");
      }
    } else if (newValue === "3") {
      setgentype("summarize");
      if (sumtext.length === 0) {
        handleRegenerate("summarize");
      }
    }
  };

  function getDlgHeadingContentfromId(id) {
    if (Array.isArray(props.dlgparalist) && props.dlgparalist != null && props.dlgparalist.length > 0) {
      console.log("find this item:");
      console.log(id);
      const conlist = props.dlgparalist.find((para) => para.id === id);
      console.log("conlist-dialog");
      console.log(conlist);
      if (conlist != null) {
        return conlist;
      }
    }
    return null;
  }

  const handleSummarize = async () => {
    setisloading(true);
    console.log("Loaded...");
    if (contextMenu != null) {
      setContextMenu(null);
    }
    console.log("Loaded...");
    var argparas = genheadings;
    var paratxt = genheadings[activeStep - 1];
    setsumcaption("Summarize for versions");
    if (gentype === "alternate") {
      paratxt = genalternate[activeStep1 - 1];
      argparas = genalternate;
      setsumcaption("Summarize for alternate");
    }

    const response = await GetContentforParagraph(
      props.processitem.heading,
      props.headings,
      props.processitem.hinttext,
      paratxt,
      true,
      argparas
    );
    setisloading(false);
    console.log("Response");
    console.log(response);
    if (response != null) {
      setsumtext(response);
    }
    settabvalue("3");
  };

  const handleRegenerate = async (strWtype = "") => {
    if (contextMenu != null) {
      setContextMenu(null);
    }
    setisloading(true);
    let selTabType = gentype;
    if (strWtype != "") {
      selTabType = strWtype;
    }
    if (selTabType === "version" || selTabType === "") {
      const response = await GetContentforParagraph(
        props.processitem.heading,
        props.headings,
        props.processitem.hinttext
      );
      setisloading(false);
      console.log("Response");
      console.log(response);
      if (response != null) {
        setpagecount((prevActiveStep) => prevActiveStep + 1);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setgenheadings([...genheadings, response]);
        setbtncaption("Regenerate");
      }
    } else if (selTabType === "alternate") {
      var paratxt = genheadings[activeStep - 1];
      var strcaptext = "Alternate for version [" + activeStep + "]";
      if (genalternate.length > 0 && gentype === "alternate") {
        paratxt = genalternate[activeStep1 - 1];
        strcaptext = "Regenerated for alternate [" + activeStep1 + "]";
      }
      const response = await GetContentforParagraph(
        props.processitem.heading,
        props.headings,
        props.processitem.hinttext,
        paratxt,
        true
      );
      setisloading(false);
      console.log("Response");
      console.log(response);
      if (response != null) {
        setpagecount1((prevActiveStep) => prevActiveStep + 1);
        setActiveStep1((prevActiveStep) => prevActiveStep + 1);
        setgenalternate([...genalternate, response]);
        setgencaptions([...gencaptions, strcaptext]);
        setbtncaption("Regenerate");
      }
      setgentype("alternate");
      settabvalue("2");
    }
  };

  useEffect(() => {
    if (props.open) {
      console.log("Props:=> ");
      console.log(props);
      console.log("genheadings");
      console.log(genheadings);
      setgentype("version");
      setdlgtitle(props.processitem.heading);
      setpagecount(0);
      setActiveStep(0);
      const myselitem = getDlgHeadingContentfromId(props.processitem.id);
      console.log(myselitem);

      setgenheadings(myselitem.content);
      setpagecount(myselitem.content.length);
      setActiveStep(0);

      setgenalternate(myselitem.altlist);
      setpagecount1(myselitem.altlist.length);
      setActiveStep1(0);

      setsumtext(myselitem.summary);
      settabvalue("1");

      setsumcaption(myselitem.summarycaption);
      setgencaptions(myselitem.altcaptions);

      if (myselitem.content != null && myselitem.content.length > 0) {
        setpagecount(myselitem.content.length);
        setActiveStep(1);
        setbtncaption("Regenerate");
      } else {
        setgentype("version");
        handleRegenerate(); //Revert comment after error
      }
    }
  }, [open]);

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleCancel = () => {
    setValue({
      generated: genheadings,
      index: activeStep,
      id: props.processitem.id,
      insertdoc: false,
      alternate: genalternate,
      sumarizetext: sumtext,
      gcaptions: gencaptions,
      gsumcaption: sumcaption,
    });
    console.log("Selected value: " + value);
    onClose({
      generated: genheadings,
      index: activeStep,
      id: props.processitem.id,
      insertdoc: false,
      alternate: genalternate,
      sumarizetext: sumtext,
      gcaptions: gencaptions,
      gsumcaption: sumcaption,
    });
    setgenheadings([]);
    setgenalternate([]);
    setsumtext("");
  };

  const InsertTextnDoc = async () => {
    if (genheadings.length > 0 && gentype === "version") {
      await InsertAIGenText(genheadings[activeStep - 1]);
    } else if (genalternate.length > 0 && gentype === "alternate") {
      await InsertAIGenText(genalternate[activeStep1 - 1]);
    } else if (sumtext.length > 0) {
      await InsertAIGenText(sumtext);
    }
  };

  return (
    <>
      <Dialog fullScreen open={open} {...other} className={classes.root}>
        <DialogTitle fontSize={15} sx={{ marginLeft: 4 }}>
          {dlgtitle}
        </DialogTitle>
        <DialogContent dividers className={classes.content} sx={{ padding: 1 }}>
          <Box sx={{ padding: 0, margin: 0 }}>
            <Box sx={{ width: "100%", p: 0, margin: 0 }}>
              <TabContext value={tabvalue}>
                <TabList aria-label="basic tabs example" onChange={handletabchange}>
                  <Tab label="Another version" value="1" sx={{ padding: 0 }} />
                  <Tab label="Alternate" value="2" sx={{ padding: 0 }} />
                  <Tab label="Summarize" value="3" sx={{ padding: 0 }} />
                </TabList>
                <TabPanel value="1" sx={{ padding: 0.5 }}>
                  <div onContextMenu={handleContextMenu} style={{ cursor: "context-menu" }}>
                    {genheadings != null &&
                      genheadings.length > 0 &&
                      genheadings[activeStep - 1] != null &&
                      genheadings[activeStep - 1].split("\n").map((i, key) => {
                        return <div key={key}>{i}</div>;
                      })}
                    <Menu
                      open={contextMenu !== null}
                      onClose={handleClose}
                      anchorReference="anchorPosition"
                      anchorPosition={
                        contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined
                      }
                    >
                      <MenuItem onClick={() => handleRegenerate("alternate")}>Alternate</MenuItem>
                      <MenuItem onClick={handleSummarize}>Summarize</MenuItem>
                    </Menu>
                  </div>
                </TabPanel>
                <TabPanel value="2" sx={{ padding: 0.5 }}>
                  <div>
                    {gencaptions != null &&
                      gencaptions.length > 0 &&
                      gencaptions[activeStep1 - 1] != null &&
                      gencaptions[activeStep1 - 1].split("\n").map((i, key) => {
                        return (
                          <div key={key}>
                            <strong>{i}</strong>
                          </div>
                        );
                      })}
                  </div>
                  <div onContextMenu={handleContextMenu} style={{ cursor: "context-menu" }}>
                    {genalternate != null &&
                      genalternate.length > 0 &&
                      genalternate[activeStep1 - 1] != null &&
                      genalternate[activeStep1 - 1].split("\n").map((i, key) => {
                        return <div key={key}>{i}</div>;
                      })}
                    <Menu
                      open={contextMenu !== null}
                      onClose={handleClose}
                      anchorReference="anchorPosition"
                      anchorPosition={
                        contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined
                      }
                    >
                      <MenuItem onClick={handleSummarize}>Summarize</MenuItem>
                    </Menu>
                  </div>
                </TabPanel>
                {sumtext.length > 0 && (
                  <TabPanel value="3" sx={{ padding: 0.5 }}>
                    <div>
                      {sumcaption != null &&
                        sumcaption.length > 0 &&
                        sumcaption.split("\n").map((i, key) => {
                          return (
                            <div key={key}>
                              <strong>{i}</strong>
                            </div>
                          );
                        })}
                    </div>
                    <div>
                      {sumtext != null &&
                        sumtext.length > 0 &&
                        sumtext.split("\n").map((i, key) => {
                          return <div key={key}>{i}</div>;
                        })}
                    </div>
                  </TabPanel>
                )}
              </TabContext>
            </Box>
            <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isloading}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </Box>
        </DialogContent>
        <DialogActions>
          <Grid container>
            <Grid item>
              {(tabvalue === "1" || gentype === "") && (
                <Pagination
                  count={pagecount}
                  page={activeStep}
                  onChange={handlePageChange}
                  hidePrevButton
                  hideNextButton
                  sx={{ marginBottom: 2 }}
                />
              )}
              {tabvalue === "2" && (
                <Pagination
                  count={pagecount1}
                  page={activeStep1}
                  onChange={handlePageChange}
                  hidePrevButton
                  hideNextButton
                  sx={{ marginBottom: 2 }}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={4}>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleRegenerate()}
                    sx={{ bgcolor: "#1C39BB", textTransform: "none" }}
                  >
                    <Typography sx={{ fontSize: 14 }}>{btncaption}</Typography>
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={InsertTextnDoc}
                    sx={{ bgcolor: "#1C39BB", textTransform: "none" }}
                  >
                    <Typography sx={{ fontSize: 14 }}>Use in doc</Typography>
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleCancel}
                    sx={{ bgcolor: "#1C39BB", textTransform: "none" }}
                  >
                    <Typography sx={{ fontSize: 14 }}>Cancel</Typography>
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PreviewModalContent;
